import React from "react";
import { withRouter } from "react-router";
import ResetPasswordForm from "../components/auth/ResetPasswordForm";
import ATechLogo from "../components/common/ATechLogo";
import SignupFormWrapper from "../components/hoc/SignupFormWrapper";

function ResetPassword({ history, match }) {
  return (
    <SignupFormWrapper>
      <div className=" col-lg-6 col-sm-10 col-12">
        <div className="bg-white box-shadow br-10 p-sm-5 p-3">
          <ATechLogo />
          <p className="common-heading mb-1">Reset Password</p>
          <p className="common-text  pb-4">
            Enter any strong password to reset your password and start using.
          </p>
          {/** Reset Up Form */}
          <ResetPasswordForm history={history} match={match} />
        </div>
      </div>
    </SignupFormWrapper>
  );
}
export default withRouter(ResetPassword);
